import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
import { CoverPanel } from './CoverArt';
import { Waves } from './Waves';
import { heroImage } from '../data/heroImage';
const chips = [{
  label: '6 volumes',
  dot: 'bg-sage'
}, {
  label: '52 sessions',
  dot: 'bg-teal'
}, {
  label: '300 pages',
  dot: 'bg-lav'
}, {
  label: '30, 40 or 50 minutes',
  dot: 'bg-peach'
}, {
  label: '5 bonuses',
  dot: 'bg-rose'
}];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Common, low-cost materials'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-paper" data-id="element-147" data-mp="sarvuvlzhael">
      <div aria-hidden="true" className="watercolor-light absolute inset-0" data-id="element-148" data-mp="sddz4j1ud3r0" />
      <div className="relative mx-auto max-w-6xl px-5 pt-10 sm:pt-14" data-id="element-149" data-mp="nbosdflnjc8q">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-12" data-id="element-150" data-mp="3d2lapfhgtb2a">
          <div data-id="element-151" data-mp="3825ywscu0bmf">
            <p className="text-sm font-semibold text-teal-deep" data-id="element-152" data-mp="381nuh8g0mr3f">
              The 4-Step Session Arc, for counselors and art therapists
            </p>
            <h1 className="mt-3 font-display text-[34px] font-semibold leading-[1.08] tracking-tight text-navy sm:text-[54px] md:text-[60px]" data-id="element-153" data-mp="3o7lqxnqt30nd">
              52 complete art-based sessions.{' '}
              <span className="wash-text" data-id="element-154" data-mp="3e9frrdwdw8m7">Not another ice-breaker.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base text-navy-soft sm:text-lg" data-id="element-155" data-mp="3eb90cyqk52wu">
              52 Weeks of Art-Based Sessions is six volumes with a ready-to-run
              session for every week of the year: the warm-up, the directive, the
              processing questions already written and the close. Open the week,
              pick your length, run it.
            </p>
            <div className="mt-6 lg:hidden" data-id="element-156" data-mp="2vjga3c2vhvst">
              <CtaButton data-id="element-157" data-mp="2hjf7ns6ymgb8">Get all 52 sessions</CtaButton>
              <div className="mt-4 flex justify-center" data-id="element-158" data-mp="2hjyot6osd0o7">
                <RatingProof data-id="element-159" data-mp="2ll0f2y0q62e1" />
              </div>
            </div>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-160" data-mp="2lmld4xm903gn">
              {chips.map(chip => <li key={chip.label} className="flex items-center gap-2 rounded-full bg-white/80 px-3 py-1.5 text-xs font-semibold text-navy-soft ring-1 ring-paper-dark" data-id="element-161" data-mp="s3us1zznrec7">
                  <span className={`h-2 w-2 rounded-full ${chip.dot}`} data-id="element-162" data-mp="ddnhs7jt11ml" />
                  {chip.label}
                </li>)}
            </ul>
          </div>

          {heroImage ? <img src={heroImage} alt="52 Weeks of Art-Based Sessions: six spiral-bound volumes, from Start Safe to Grow Forward" width={1344} height={752} className="w-full rounded-3xl object-cover shadow-cover" data-id="element-163" data-mp="161ay3ae1l63f" /> : <CoverPanel data-id="element-164" data-mp="3lt756pxsnptq" />}
        </div>

        <div className="mt-10 flex flex-col items-center" data-id="element-165" data-mp="3lquftrppid6n">
          <div className="hidden w-full max-w-md lg:block" data-id="element-166" data-mp="3hqagqilkozhv">
            <CtaButton data-id="element-167" data-mp="1x9b0yopm2f6r">Get 52 Weeks of Art-Based Sessions</CtaButton>
          </div>
          <div className="mt-5 hidden lg:block" data-id="element-168" data-mp="1x7hwng2h071x">
            <RatingProof data-id="element-169" data-mp="21bxy9551wsbc" />
          </div>
          <p className="mt-4 max-w-md text-center text-sm text-navy-soft" data-id="element-170" data-mp="218tl3i9lym8j">
            Written for school and mental health counselors, social workers and
            art therapists who use art in session. One-to-one, in groups and
            online. No subscription.
          </p>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-navy-muted" data-id="element-171" data-mp="2fzj2x3hkqzld">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-172" data-mp="2p0qnyjv2y3xi">
                <span className="h-1.5 w-1.5 rounded-full bg-teal" data-id="element-173" data-mp="2oye8qegpi7o5" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
      <Waves to="#FFFFFF" className="relative mt-8" data-id="element-174" data-mp="uniyz8tscmjs" />
    </section>;
}